import React from 'react';
import { SmartLink } from '../SmartLink';
import { productCatalog } from '../../data/products/shared';
import { solutionCatalog } from '../../data/solutions/catalog';
import type { CustomerStory } from '../../types/story';
export function StoryFactsCard({
  story
}: {
  story: CustomerStory;
}) {
  const industry = solutionCatalog[story.industry];
  const facts = [{
    label: 'Business',
    value: story.business
  }, {
    label: 'Industry',
    value: industry?.title ?? ''
  }, {
    label: 'Location',
    value: story.location
  }, {
    label: 'Staff',
    value: story.staff
  }, {
    label: 'Using Kayko since',
    value: story.since
  }];
  return <aside aria-label="Business facts" className="rounded-[14px] border border-canvas-line bg-white p-6" data-id="element-1634" data-mp="297gh1ikgytej">
      <dl className="space-y-4" data-id="element-1635" data-mp="25760jbz1wklf">
        {facts.map(fact => <div key={fact.label} data-id="element-1636" data-mp="31pki9bq999yy">
            <dt className="text-[13px] text-ink-muted" data-id="element-1637" data-mp="31qlql8fvzicz">{fact.label}</dt>
            <dd className="mt-0.5 text-[15px] font-semibold text-ink" data-id="element-1638" data-mp="2wxj4tmhcpd7c">{fact.value}</dd>
          </div>)}
        <div data-id="element-1639" data-mp="33obwv1x8fk90">
          <dt className="text-[13px] text-ink-muted" data-id="element-1640" data-mp="33nslk4237u3y">Products used</dt>
          <dd className="mt-2 flex flex-wrap gap-2" data-id="element-1641" data-mp="38l29ff9tvxpo">
            {story.products.map(key => {
            const product = productCatalog[key];
            if (!product) return null;
            return <SmartLink key={key} href={product.href} className="rounded-full border border-canvas-line px-3 py-1 text-[13px] font-medium text-ink transition-colors duration-150 ease-out hover:border-brand/40 hover:text-brand" data-id="element-1642" data-mp="2yupqfrhnwcln">
                  {product.title}
                </SmartLink>;
          })}
          </dd>
        </div>
        <div className="border-t border-canvas-line pt-4" data-id="element-1643" data-mp="2fziv2otxii6h">
          <dt className="text-[13px] text-ink-muted" data-id="element-1644" data-mp="981kl4slczyz">Plan</dt>
          <dd className="mt-0.5 flex items-center justify-between gap-3" data-id="element-1645" data-mp="e630xhymul6r">
            <span className="text-[15px] font-semibold text-ink" data-id="element-1646" data-mp="e3z0xb3uu6br">{story.plan}</span>
            <SmartLink href="/pricing" className="text-[13px] font-semibold text-brand hover:text-brand-hover" data-id="element-1647" data-mp="cqh5o3jqthum">
              See plans
            </SmartLink>
          </dd>
        </div>
      </dl>
    </aside>;
}